import { BottleWine, ReceiptEuro } from "lucide-react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { roundNumberToFixed } from "@/lib/money.util";
import { QuotationUpdateBoFormData } from "@/types/forms/bo/expeditionBo.form";

export const DeliveryContentTotal = () => {
  const { t } = useTranslation("boExpeditionForm");
  const { control } = useFormContext<QuotationUpdateBoFormData>();

  const watch = useWatch({
    control,
    name: "deliveryContent",
  });

  const totalBtls = roundNumberToFixed(
    watch?.reduce((acc: number, item) => acc + Number(item.numberOfBottles || 0), 0),
    2,
  );

  const totalPrice =
    roundNumberToFixed(
      watch?.reduce(
        (acc: number, item) =>
          acc + Number(item.unitPrice || 0) * Number(item.numberOfBottles || 0),
        0,
      ),
      2,
    ) + " €";

  return (
    <div className="grid grid-cols-2 gap-2">
      <div className="flex flex-col gap-2">
        <p className="text-sm text-black">{t("deliveryContentTotal.bottlesLabel")}</p>
        <div className="flex flex-row items-center gap-2">
          <BottleWine className="h-6 w-6 shrink-0 text-black" />
          <p className="text-md text-gray-900">{totalBtls}</p>
        </div>
      </div>
      <div className="flex flex-col gap-2 border-l-2 border-gray-200 pl-2">
        <p className="text-sm text-black">{t("deliveryContentTotal.totalPriceLabel")}</p>
        <div className="flex flex-row items-center gap-2">
          <ReceiptEuro className="h-6 w-6 shrink-0 text-black" />
          <p className="text-md text-gray-900">{totalPrice}</p>
        </div>
      </div>
    </div>
  );
};
